// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAbG8gRRamkVPygJagdkZk_2znpz4ARtj0",
  authDomain: "ecom-92504.firebaseapp.com",
  projectId: "ecom-92504",
  storageBucket: "ecom-92504.appspot.com",
  messagingSenderId: "953038462547",
  appId: "1:953038462547:web:1ea499deef86d6a002f0a6",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export default app;
